import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserRole } from "@/hooks/use-user-role";

type CreatorOnlyRouteProps = {
  children: React.ReactNode;
};

export function CreatorOnlyRoute({ children }: CreatorOnlyRouteProps) {
  const { userRole } = useUserRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (userRole === "student") {
      navigate("/dashboard/products", { replace: true });
    }
  }, [userRole, navigate]);

  if (userRole === "student") {
    return null;
  }

  return <>{children}</>;
}

